import { render, staticRenderFns } from "./TagMarker.vue?vue&type=template&id=6ca560fc&scoped=true&"
import script from "./TagMarker.vue?vue&type=script&lang=ts&"
export * from "./TagMarker.vue?vue&type=script&lang=ts&"
import style0 from "./TagMarker.vue?vue&type=style&index=0&id=6ca560fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca560fc",
  null
  
)

export default component.exports